module.exports = __webpack_public_path__ + "img/ng.2c91f30a.svg";